







import { Component, Prop, Mixins } from 'vue-property-decorator';
import IsAuthorizedMixin from '@/mixins/isAuthorized';

@Component
export default class ModuleBasketButton extends Mixins(IsAuthorizedMixin) {
  @Prop({ type: Boolean, default: true })
  readonly isBasketMode!: boolean;

  get btnClass(): string {
    const { isAuthorized, isBasketMode } = this;
    // if (!isAuthorized) return 'basket_disabled';
    return isBasketMode ? 'basket_add' : 'basket_remove';
  }

  clickHandler() {
    this.$emit('basket');
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/modules/card/components/modulebasketbutton/ModuleBasketButton.vue